// extracted by mini-css-extract-plugin
export default {"wrapper":"pro_upsell_modal__wrapper--VYQc","footer":"pro_upsell_modal__footer--TAtb","footerButtons":"pro_upsell_modal__footerButtons--NPlg","table":"pro_upsell_modal__table--B7lO"};